export const TOTAL_STEPS = 3;
export const NEW_ONBOARDING_TOTAL_STEPS = 5;
